export default "__VITE_ASSET__CDPN9q0T__"